export class ShowNavbar {
  static type = '[Navbar] Show navbar';
}

export class CloseNavbar {
  static type = '[Navbar] close navbar';
}
